<template>
  <div id="paginaChartBiglietteria">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <div id="selezione" ref="selezione" v-show="true">
      <b-row class="match-height">
        <!-- Card con Elementi Input: Nuovi Componenti -->
        <b-col xl="12" md="12">
          <b-card tag="article" class="mb-2">
            <b-card-header class="align-items-baseline">
              <div>
                <b-card-title>Visualizzazione Chart Biglietteria</b-card-title>
                <b-card-text class="mb-0" />
              </div>
              <b-dropdown
                variant="link"
                no-caret
                right
                class="chart-dropdown"
                toggle-class="p-0"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item href="#"> ... </b-dropdown-item>
              </b-dropdown>
            </b-card-header>
            <b-card-body class="mb-0"
              >'
              <!-- card body -->
              <b-row>
                <!-- Input di tipo dropdown collegato: stagione  -->
                <b-col xl="12" md="12" class="pt-1">
                  <ejs-dropdownlist
                    id="dropStagioni"
                    ref="dropStagioni"
                    :query="queryStagioni"
                    :dataSource="stagioniData"
                    :index="stagioniIndex"
                    :fields="stagioniFields"
                    v-model="stagione"
                    :change="onStagioneChange"
                    placeholder="Seleziona una Stagione"
                  ></ejs-dropdownlist>
                </b-col>
                <!-- Input di tipo dropdown collegato: sceltaCharts  -->
                <b-col xl="12" md="12" class="pt-1">
                  <ejs-dropdownlist
                    id="dropSceltaCharts"
                    ref="dropSceltaCharts"
                    :query="querySceltaCharts"
                    :dataSource="sceltaChartsData"
                    :index="sceltaChartsIndex"
                    :fields="sceltaChartsFields"
                    :enabled="dropSceltaChartsEnabled"
                    v-model="sceltaCharts"
                    :change="onSceltaChartsChange"
                    placeholder="Seleziona la tipologia di Visualizzazione"
                  ></ejs-dropdownlist>
                </b-col>

                <!-- Button:  -->
                <b-col
                  xl="12"
                  md="12"
                  class="mt-1"
                  v-show="mostraButtonRefresh"
                >
                  <ejs-button id="refreshChart1" @click.native="refreshChart()"
                    >Refresh Chart
                  </ejs-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <!-- loader -->
    <div id="loader" ref="loader" v-show="loading">
      <b-row align-h="center">
        <b-col xl="12" md="12" class="pt-1 text-center">
          <b-spinner label="Loading..."></b-spinner>
        </b-col>
      </b-row>
    </div>

    <div id="contenuto" ref="contenuto" v-show="mostraContenuto">
      <b-row class="match-height">
        <!-- GRAFICI CATE ------------------------------------------------------------------------------------------------------------ -->

        <!-- 004b - Card con Chart 007 - Areachart - Area Line - Cate 012_02-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI TOTALI"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_007_cate_cumulativo"
              ref="chartcontainer_007_cate_cumulativo"
              :title="title_cate_cumulativo"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_001_cate_012_02"
              :primaryYAxis="primaryYAxis_001_cate_cumulativo"
              :tooltip="tooltip_xy"
              :chartArea="chartArea_001"
              :textRender="onTextRenderEuro"
              :palettes="palettes_incassi"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_vendite_cumulative_01"
                  type="Area"
                  xName="x"
                  yName="y"
                  name="Incassi Totali"
                  width="2"
                  opacity="0.5"
                  :marker="marker_001"
                >
                </e-series>
                <!-- <e-series
                  :dataSource="seriesData_001_cate_012_02_2"
                  type="Area"
                  xName="x"
                  yName="y"
                  name="Incassi OnLine"
                  width="2"
                  opacity="0.5"
                  :marker="marker_001"
                >
                </e-series> -->
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 004 - Card con Chart 007 - Areachart - Area Line - Cate 012_02-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI MENSILI BIGLIETTERIA"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_007_cate_012_02"
              ref="chartcontainer_007_cate_012_02"
              :title="title_cate_012_02"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_001_cate_012_02"
              :axisLabelRender="axisLabelRender1"
              :primaryYAxis="primaryYAxis_001_cate_012_02"
              :tooltip="tooltip_xy"
              :chartArea="chartArea_001"
              :textRender="onTextRenderEuro"
              :palettes="palettes_incassi"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_001_cate_012_02_1"
                  type="Area"
                  xName="x"
                  yName="y"
                  name="Incassi Mensili"
                  width="2"
                  opacity="0.5"
                  :marker="marker_001"
                >
                </e-series>
                <!-- <e-series
                  :dataSource="seriesData_001_cate_012_02_2"
                  type="Area"
                  xName="x"
                  yName="y"
                  name="Incassi OnLine"
                  width="2"
                  opacity="0.5"
                  :marker="marker_001"
                >
                </e-series> -->
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 001 - Card con Chart 016 - Barchart - Bar - CATE 010: best seller e importo-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI SPETTACOLI"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010"
              ref="chartcontainer_016_cate_010"
              :title="title_bestSeller"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender"
              :seriesRender="onSeriesRender"
              height="1500"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_bestSeller"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
              <!-- colori graduati -->
              <e-rangecolorsettings>
                <e-rangecolorsetting
                  start="1"
                  end="3000"
                  :colors="colors1"
                ></e-rangecolorsetting>
                <e-rangecolorsetting
                  start="3001"
                  end="5000"
                  :colors="colors2"
                ></e-rangecolorsetting>
                <e-rangecolorsetting
                  start="5000"
                  end="15000"
                  :colors="colors3"
                ></e-rangecolorsetting>
                <e-rangecolorsetting
                  start="15000"
                  end="100000"
                  :colors="colors4"
                ></e-rangecolorsetting>
              </e-rangecolorsettings>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 002 - Card con Chart 011 - Barchart - Incassi per tipologia di spettacolo -->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI PER TIPOLOGIA"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_011"
              ref="chartcontainer_011"
              :title="title_tipologia"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :pointRender="pointRender_002"
              :textRender="onTextRenderEuro"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia"
                  type="Column"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 002b - Card con Chart 025 - Pie - Incassi per tipologia di spettacolo -->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI PERCENTUALI PER TIPOLOGIA"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_025_002b"
              :title="title_tipologia_perc"
              :titleStyle="titleStyleBold"
              :legendSettings="legendSettings_border"
              :tooltip="tooltip_xy"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025_cate"
              :center="center_025_cate"
              :pointRender="pointRender_002"
              height="500"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_tipologia_pie"
                  :startAngle="startAngle"
                  :endAngle="endAngle"
                  :explodeOffset="explodeOffset"
                  :explodeIndex="explodeIndex"
                  :radius="radius"
                  xName="x"
                  yName="y"
                  :dataLabel="dataLabel_025_cate"
                  name="Tipologia"
                  innerRadius="40%"
                  explode="true"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 003 - Card con Chart 016 - Barchart - Opera importo-->
        <b-col xl="12" md="12">
          <b-card title="INCASSI OPERA" tag="article" class="mb-2" height="100">
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010a"
              ref="chartcontainer_016_cate_010a"
              :title="title_opera"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender_03a"
              :seriesRender="onSeriesRender_03a"
              :palettes="palettes_opera"
              height="500"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia_opera"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 003b - Card con Chart 016 - Barchart - Prosa importo-->
        <b-col xl="12" md="12">
          <b-card title="INCASSI PROSA" tag="article" class="mb-2" height="100">
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010b"
              ref="chartcontainer_016_cate_010b"
              :title="title_prosa"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender_03b"
              :seriesRender="onSeriesRender_03b"
              :palettes="palettes_prosa"
              height="500"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia_prosa"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 003c - Card con Chart 016 - Barchart - Musical importo-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI MUSICAL"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010c"
              ref="chartcontainer_016_cate_010c"
              :title="title_musical"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender_03c"
              :seriesRender="onSeriesRender_03c"
              :palettes="palettes_musical"
              :height="chart_height_musical"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia_musical"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 003d - Card con Chart 016 - Barchart - Balletto importo-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI BALLETTO"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010d"
              ref="chartcontainer_016_cate_010d"
              :title="title_balletto"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender_03d"
              :seriesRender="onSeriesRender_03d"
              :palettes="palettes_balletto"
              height="300"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia_balletto"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 003e - Card con Chart 016 - Barchart - Concerto importo-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI CONCERTO"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010e"
              ref="chartcontainer_016_cate_010e"
              :title="title_concerto"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender_03e"
              :seriesRender="onSeriesRender_03e"
              :palettes="palettes_concerto"
              height="1000"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia_concerto"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 003f - Card con Chart 016 - Barchart - Eventi diversi importo-->
        <b-col xl="12" md="12">
          <b-card
            title="INCASSI EVENTI DIVERSI"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_016_cate_010f"
              ref="chartcontainer_016_cate_010f"
              :title="title_eventi_diversi"
              :titleStyle="titleStyleBold"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
              :textRender="onTextRender_03f"
              :seriesRender="onSeriesRender_03f"
              :palettes="palettes_eventi_diversi"
              height="500"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_tipologia_eventi_diversi"
                  type="Bar"
                  xName="x"
                  yName="y"
                  width="2"
                  :marker="marker_011b"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        

        

        <!-- 101 - Card con Chart 025 - Pie - CATE 001: genere del pubblico -->
        <b-col xl="12" md="12" v-show="showChartPubblico">
          <b-card
            title="Pubblico per genere prova"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_025_cate_001"
              :title="title_025_cate_001"
              :legendSettings="legendSettings_025_cate"
              :tooltip="tooltip_025_cate"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025_cate"
              :center="center_025_cate"
              height="500"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_025_cate_001"
                  :startAngle="startAngle"
                  :endAngle="endAngle"
                  :explodeOffset="explodeOffset"
                  :explodeIndex="explodeIndex"
                  :radius="radius"
                  xName="x"
                  yName="y"
                  :dataLabel="dataLabel_025_cate"
                  name="Genere"
                  innerRadius="0%"
                  explode="true"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 102 - Card con Chart 025 - Pie - CATE 002: età del pubblico -->
        <b-col xl="12" md="12" v-show="showChartPubblico">
          <b-card
            title="Pubblico per età prova"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_025_cate_002"
              :title="title_025_cate_002"
              :legendSettings="legendSettings_025_cate"
              :tooltip="tooltip_025_cate"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025_cate"
              :center="center_025_cate"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_025_cate_002"
                  :startAngle="startAngle"
                  :endAngle="endAngle"
                  :explodeOffset="explodeOffset"
                  :explodeIndex="explodeIndex"
                  :radius="radius"
                  xName="x"
                  yName="y"
                  :dataLabel="dataLabel_025_cate"
                  name="Fasca d'eta"
                  innerRadius="0%"
                  explode="true"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 103 - Card con Chart 025 - Pie - CATE 003: provenienza pubblico -->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Pubblico per provenienza"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_025_cate_003"
              :title="title_025_cate_003"
              :legendSettings="legendSettings_025_cate"
              :tooltip="tooltip_025_cate"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025_cate"
              :center="center_025_cate"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_025_cate_003"
                  :startAngle="startAngle"
                  :endAngle="endAngle"
                  :explodeOffset="explodeOffset"
                  :explodeIndex="explodeIndex"
                  :radius="radius"
                  xName="x"
                  yName="y"
                  :dataLabel="dataLabel_025_cate"
                  name="Provenienza"
                  innerRadius="0%"
                  explode="true"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 104 - Card con Chart 027 - Donut - Cate 004_02 genere del pubblico 2022 -->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Card con Chart 027 Donut"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_027_cate_004_02"
              :title="title_011_cate"
              :legendSettings="legendSettings_025_cate"
              :tooltip="tooltip_025_cate"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025"
              :center="center_025"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_027_cate_004_02"
                  radius="70%"
                  xName="x"
                  yName="y"
                  startAngle="0"
                  :dataLabel="dataLabel_025_cate"
                  endAngle="360"
                  innerRadius="40%"
                  name="Project"
                  explode="true"
                  explodeOffset="10%"
                  :explodeIndex="explodeIndex_027"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 105 - Card con Chart 027 - Donut - Cate 005_02 età del pubblico 2022 -->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Card con Chart 027 Donut"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_027_cate_005_02"
              :title="title_025_cate_005"
              :legendSettings="legendSettings_025_cate"
              :tooltip="tooltip_025_cate"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025"
              :center="center_025"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_025_cate_02"
                  radius="70%"
                  xName="x"
                  yName="y"
                  startAngle="0"
                  :dataLabel="dataLabel_025_cate"
                  endAngle="360"
                  innerRadius="40%"
                  name="Fascia d'età"
                  explode="true"
                  explodeOffset="10%"
                  :explodeIndex="explodeIndex_027"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 106 - Card con Chart 027 - Donut - Cate 006_02 provenienza del pubblico 2022 -->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Card con Chart 027 Donut"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-accumulationchart
              ref="pie"
              style="display: block"
              align="center"
              id="chartcontainer_027_cate_006_02"
              :title="title_025_cate_006"
              :legendSettings="legendSettings_025_cate"
              :tooltip="tooltip_025_cate"
              enableSmartLables="true"
              :enableAnimation="enableAnimation_025"
              :center="center_025"
            >
              <e-accumulation-series-collection>
                <e-accumulation-series
                  :dataSource="seriesData_025_cate_01"
                  radius="70%"
                  xName="x"
                  yName="y"
                  startAngle="0"
                  :dataLabel="dataLabel_025_cate"
                  endAngle="360"
                  innerRadius="40%"
                  name="Project"
                  explode="true"
                  explodeOffset="10%"
                  :explodeIndex="explodeIndex_027"
                >
                </e-accumulation-series>
              </e-accumulation-series-collection>
            </ejs-accumulationchart>
          </b-card>
        </b-col>

        <!-- 201 - Card con Chart 020 - Stacked Bar 100 - Cate 007: genere del pubblico per spettacolo  -->
        <b-col xl="12" md="12" v-show="showChartPubblico">
          <b-card
            title="Genere del pubblico per spettacolo"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_020_cate_007"
              ref="chartcontainer_020_cate_007"
              :title="title_020_cate_007"
              :primaryXAxis="primaryXAxis_020"
              :primaryYAxis="primaryYAxis_020"
              :tooltip="tooltip_018"
              :chartArea="chartArea_020"
              height="700"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_020_cate_007"
                  type="StackingBar100"
                  xName="x"
                  yName="y0"
                  name="Donne"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_020_cate_007"
                  type="StackingBar100"
                  xName="x"
                  yName="y1"
                  name="Uomini"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_020_cate_007"
                  type="StackingBar100"
                  xName="x"
                  yName="y2"
                  name="Non specificato"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 202 - Card con Chart 019 - Stacked Bar - Cate 007: genere del pubblico per spettacolo-->
        <b-col xl="12" md="12" v-show="showChartPubblico">
          <b-card
            title="Genere del pubblico per spettacolo"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_019_cate_007_2"
              ref="chartcontainer_019_cate_007_2"
              :title="title_019_cate_007_2"
              :primaryXAxis="primaryXAxis_019"
              :primaryYAxis="primaryYAxis_019_cate_007_2"
              :tooltip="tooltip_cate_007"
              :chartArea="chartArea_019"
              height="700"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_019_cate_007_01"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Donne"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_007_02"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Uomini"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_007_03"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Non specificato"
                  width="2"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 203 - Card con Chart 019 - Stacked Bar - Cate 008: età del pubblico per spettacolo-->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Età del pubblico per spettacolo"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_019_cate_008"
              ref="chartcontainer_019_cate_008"
              :title="title_019_cate_008"
              :primaryXAxis="primaryXAxis_019"
              :primaryYAxis="primaryYAxis_019_cate_007_2"
              :tooltip="tooltip_cate_007"
              :chartArea="chartArea_019"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_019_cate_008_01"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="<20"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_008_02"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="20-40"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_008_03"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="40-60"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_008_04"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="60-80"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_008_05"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Non specificato"
                  width="2"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 204 - Card con Chart 019 - Stacked Bar - Cate 009: provenienza del pubblico per spettacolo-->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Provenienza del pubblico per spettacolo"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_019_cate_009"
              ref="chartcontainer_019_cate_009"
              :title="title_019_cate_009"
              :primaryXAxis="primaryXAxis_019"
              :primaryYAxis="primaryYAxis_019_cate_007_2"
              :tooltip="tooltip_cate_007"
              :chartArea="chartArea_019"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_019_cate_009_01"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Novara"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_009_02"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Piemonte"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_009_03"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Lombardia"
                  width="2"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_019_cate_009_04"
                  type="StackingBar"
                  xName="x"
                  yName="y"
                  name="Altro"
                  width="2"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 107 - Card con Chart 011 - Barchart - Column - Cate 013-->
        <b-col xl="6" md="6" v-show="showChartPubblico">
          <b-card
            title="Pubblico per genere e provenienza"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_011_cate_013"
              ref="chartcontainer_011_cate_013"
              :title="title_013_cate"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_011_001_cate_013"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Novara"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_011_002_cate_013"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Piemonte"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_011_003_cate_013"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Lombardia"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_011_004_cate_013"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Altro"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>

        <!-- 108 - Card con Chart 011 - Barchart - Column - Cate 014-->
        <b-col xl="12" md="12" v-show="showChartPubblico">
          <b-card
            title="Pubblico per età e provenienza"
            tag="article"
            class="mb-2"
            height="100"
          >
            <!-- card body -->
            <ejs-chart
              style="display: block"
              align="center"
              id="chartcontainer_011_cate_014"
              ref="chartcontainer_011_cate_014"
              :title="title_014_cate"
              :primaryXAxis="primaryXAxis_011"
              :primaryYAxis="primaryYAxis_011"
              :tooltip="tooltip_001"
              :chartArea="chartArea_011"
            >
              <e-series-collection>
                <e-series
                  :dataSource="seriesData_011_001_cate_014"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Novara"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_011_002_cate_014"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Piemonte"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_011_003_cate_014"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Lombardia"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
                <e-series
                  :dataSource="seriesData_011_004_cate_014"
                  type="Column"
                  xName="x"
                  yName="y"
                  name="Altro"
                  width="2"
                  :marker="marker_011"
                >
                </e-series>
              </e-series-collection>
            </ejs-chart>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Browser } from "@syncfusion/ej2-base";

import {
  Crosshair,
  SplineRangeAreaSeries,
  StripLine,
  AreaSeries,
  AccumulationChartPlugin,
  AccumulationTooltip,
  SplineSeries,
  PolarSeries,
  RadarSeries,
  FunnelSeries,
  PyramidSeries,
  PieSeries,
  AccumulationDataLabel,
  AccumulationLegend,
  ChartPlugin,
  HistogramSeries,
  BubbleSeries,
  ScatterSeries,
  StackingColumnSeries,
  BarSeries,
  RangeColumnSeries,
  ColumnSeries,
  StackingAreaSeries,
  RangeAreaSeries,
  StepLineSeries,
  SplineAreaSeries,
  Category,
  Legend,
  Tooltip,
  DateTime,
  Zoom as ChartZoom,
} from "@syncfusion/ej2-vue-charts";
Vue.use(ChartPlugin);
Vue.use(AccumulationChartPlugin);

import { enableRipple } from "@syncfusion/ej2-base";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import {
  DocumentEditorContainerPlugin,
  DocumentEditorContainerComponentm,
  Toolbar,
} from "@syncfusion/ej2-vue-documenteditor";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

import useJwt from "@/auth/jwt/useJwt";

import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  EmbedPlugin,
  TablePlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormCheckboxPlugin,
  FormSelectPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";

Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(EmbedPlugin);
Vue.use(TablePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormSelectPlugin);
Vue.use(SpinnerPlugin);

Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
enableRipple(true);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DocumentEditorContainerPlugin);
Vue.use(DropDownButtonPlugin);

const chartUrl = "/demo/api/chart/ricerca";
// una sola API per tutte le chart con una POST che indica quale insieme dati ed eventuali parametri

let materialColors = [
  "#00bdae",
  "#404041",
  "#357cd2",
  "#e56590",
  "#f8b883",
  "#70ad47",
  "#dd8abd",
  "#7f84e8",
  "#7bb4eb",
  "#ea7a57",
  "#404041",
  "#00bdae",
];
let fabricColors = [
  "#4472c4",
  "#ed7d31",
  "#ffc000",
  "#70ad47",
  "#5b9bd5",
  "#c1c1c1",
  "#6f6fe2",
  "#e269ae",
  "#9e480e",
  "#997300",
  "#4472c4",
  "#70ad47",
  "#ffc000",
  "#ed7d31",
];
let bootstrapColors = [
  "#a16ee5",
  "#f7ce69",
  "#55a5c2",
  "#7ddf1e",
  "#ff6ea6",
  "#7953ac",
  "#b99b4f",
  "#407c92",
  "#5ea716",
  "#b91c52",
];
let highContrastColors = [
  "#79ECE4",
  "#E98272",
  "#DFE6B6",
  "#C6E773",
  "#BA98FF",
  "#FA83C3",
  "#00C27A",
  "#43ACEF",
  "#D681EF",
  "#D8BC6E",
];

// months label in italian
let itaMonths = [
  "Gen",
  "Apr",
  "Mag",
  "Giu",
  "Lug",
  "Ago",
  "Set",
  "Ott",
  "Nov",
  "Dic",
];

// per Chart 024
let chartData_024 = [];
let points_024 = [
  5.25, 7.75, 0, 8.275, 9.75, 7.75, 8.275, 6.25, 5.75, 5.25, 23.0, 26.5, 27.75,
  25.025, 26.5, 26.5, 28.025, 29.25, 26.75, 27.25, 26.25, 25.25, 34.5, 25.625,
  25.5, 26.625, 36.275, 36.25, 26.875, 40.0, 43.0, 46.5, 47.75, 45.025, 56.5,
  56.5, 58.025, 59.25, 56.75, 57.25, 46.25, 55.25, 44.5, 45.525, 55.5, 46.625,
  46.275, 56.25, 46.875, 43.0, 46.25, 55.25, 44.5, 45.425, 55.5, 56.625, 46.275,
  56.25, 46.875, 43.0, 46.25, 55.25, 44.5, 45.425, 55.5, 46.625, 56.275, 46.25,
  56.875, 41.0, 63.0, 66.5, 67.75, 65.025, 66.5, 76.5, 78.025, 79.25, 76.75,
  77.25, 66.25, 75.25, 74.5, 65.625, 75.5, 76.625, 76.275, 66.25, 66.875, 80.0,
  85.25, 87.75, 89.0, 88.275, 89.75, 97.75, 98.275, 96.25, 95.75, 95.25,
];
points_024.map((value) => {
  chartData_024.push({
    y: value,
  });
});

// par Chart 043
let series_043 = [];
let point_043 = Object;
let value_043 = 40;
let i = 0;
for (i = 1; i < 500; i++) {
  if (Math.random() > 0.5) {
    value_043 += Math.random();
  } else {
    value_043 -= Math.random();
  }
  point_043 = { x: new Date(1950, i + 2, i), y: value_043.toFixed(1) };
  series_043.push(point_043);
}

// istogramma CATE
// per Chart 024
let chartData_024_cate = [];
let points_024_cate = [
  54, 54, 54, 100, 100, 100, 100, 100, 100, 100, 120, 120, 120, 120, 200, 200,
  400,
];
points_024_cate.map((value) => {
  chartData_024_cate.push({
    y: value,
  });
});

let total = 0;
let total03a = 0;
let total03b = 0;
let total03c = 0;
let total03d = 0;
let total03e = 0;
let total03f = 0;
let myWidth = 0.2;

export default Vue.extend({
  data: function () {
    return {
      // per fix grafici Cate
      seriesData_bestSeller: null,
      seriesData_tipologia: null,
      seriesData_tipologia_pie: null,
      seriesData_tipologia_opera: null,
      seriesData_tipologia_prosa: null,
      seriesData_tipologia_musical: null,
      seriesData_tipologia_balletto: null,
      seriesData_tipologia_concerto: null,
      seriesData_tipologia_eventi_diversi: null,
      title_011_cate: null,

      // spinner
      loading: false,

      // gestione altezze dei chart
      horizontalchart_single_bar_height: 100,
      chart_height_musical: "300",

      // per dropdown combinati stagione sceltaCharts
      stagione: null,
      sceltaCharts: null,
      stagioniData: [
        { label: "2022", StagioneId: "2022" },
        { label: "2023", StagioneId: "2023" },
        { label: '2024', StagioneId: '2024' },
        { label: '2025', StagioneId: '2025' },
        { label: '2026', StagioneId: '2026' },
      ],
      sceltaChartsData: [
        { label: "Grafici completi", id: "graficiCompleti" },
        // { label: "Dettaglio Vendite", id: "dettaglioVendite" },
      ],
      stagioniFields: { value: "StagioneId", text: "label" },
      sceltaChartsFields: { value: "id", text: "label" },
      stagioniIndex: -1,
      sceltaChartsIndex: -1,
      dropSceltaChartsEnabled: false,
      queryStagioni: null,
      querySceltaCharts: null,
      // per visualizzare i charts
      mostraContenuto: false,
      showChartPubblico: false,
      mostraButtonRefresh: false,
      // per Chart 001
      title_001: "Inflation - Consumer Price",
      tooltip_001: {
        enable: true,
        format: "<b>${point.y}€</b>",
      },
      tooltip_xy: {
        enable: true,
        format: "${point.x}: <b>${point.y}€</b>",
      },

      chartArea_001: {
        border: {
          width: 0,
        },
      },
      marker_001: {
        visible: true,
        height: 10,
        width: 10,
      },
      primaryXAxis_001: {
        valueType: "DateTime",
        labelFormat: "y",
        intervalType: "Years",
        edgeLabelPlacement: "Shift",
        majorGridLines: { width: 0 },
      },
      primaryYAxis_001: {
        labelFormat: "{value}%",
        rangePadding: "None",
        minimum: 0,
        maximum: 100,
        interval: 20,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },
      seriesData_001_01: [
        { x: new Date(2005, 0, 1), y: 21 },
        { x: new Date(2006, 0, 1), y: 24 },
        { x: new Date(2007, 0, 1), y: 36 },
        { x: new Date(2008, 0, 1), y: 38 },
        { x: new Date(2009, 0, 1), y: 54 },
        { x: new Date(2010, 0, 1), y: 57 },
        { x: new Date(2011, 0, 1), y: 70 },
      ],
      seriesData_001_02: [
        { x: new Date(2005, 0, 1), y: 28 },
        { x: new Date(2006, 0, 1), y: 44 },
        { x: new Date(2007, 0, 1), y: 48 },
        { x: new Date(2008, 0, 1), y: 50 },
        { x: new Date(2009, 0, 1), y: 66 },
        { x: new Date(2010, 0, 1), y: 78 },
        { x: new Date(2011, 0, 1), y: 84 },
      ],

      // per Chart 002
      title_002: "Incassi",
      tooltip_002: {
        enable: true,
      },
      chartArea_002: {
        border: {
          width: 0,
        },
      },
      marker_002: {
        visible: true,
        height: 10,
        width: 10,
      },
      primaryXAxis_002: {
        valueType: "DateTime",
        labelFormat: "d/M/y",
        intervalType: "Days",
        edgeLabelPlacement: "Shift",
        majorGridLines: { width: 0 },
      },
      primaryYAxis_002: {
        labelFormat: "{value}",
        rangePadding: "None",
        minimum: 500,
        maximum: 1500,
        interval: 250,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },
      seriesData_002_01: [
        { x: new Date(2021, 8, 12), y: 833.58 },
        { x: new Date(2021, 9, 12), y: 827.3000000000002 },
        { x: new Date(2021, 10, 12), y: 895.4199999999998 },
      ],

      // Per PDF 01
      // serviceUrl:
      //   "https://ej2services.syncfusion.com/production/web-services/api/pdfviewer",
      // documentPath: "PDF_Succinctly.pdf",

      // Per Chart 010
      title_010: "Trend in Sales",
      seriesData_010_001: [
        { x: new Date(2000, 0, 1), y: 0.61, y1: 0.03, y2: 0.48, y3: 0.23 },
        { x: new Date(2001, 0, 1), y: 0.81, y1: 0.05, y2: 0.53, y3: 0.17 },
        { x: new Date(2002, 0, 1), y: 0.91, y1: 0.06, y2: 0.57, y3: 0.17 },
        { x: new Date(2003, 0, 1), y: 1.0, y1: 0.09, y2: 0.61, y3: 0.2 },
        { x: new Date(2004, 0, 1), y: 1.19, y1: 0.14, y2: 0.63, y3: 0.23 },
        { x: new Date(2005, 0, 1), y: 1.47, y1: 0.2, y2: 0.64, y3: 0.36 },
        { x: new Date(2006, 0, 1), y: 1.74, y1: 0.29, y2: 0.66, y3: 0.43 },
        { x: new Date(2007, 0, 1), y: 1.98, y1: 0.46, y2: 0.76, y3: 0.51 },
        { x: new Date(2008, 0, 1), y: 1.99, y1: 0.64, y2: 0.77, y3: 0.72 },
        { x: new Date(2009, 0, 1), y: 1.7, y1: 0.75, y2: 0.55, y3: 1.29 },
        { x: new Date(2010, 0, 1), y: 1.48, y1: 1.06, y2: 0.54, y3: 1.38 },
        { x: new Date(2011, 0, 1), y: 1.38, y1: 1.25, y2: 0.57, y3: 1.82 },
        { x: new Date(2012, 0, 1), y: 1.66, y1: 1.55, y2: 0.61, y3: 2.16 },
        { x: new Date(2013, 0, 1), y: 1.66, y1: 1.55, y2: 0.67, y3: 2.51 },
        { x: new Date(2014, 0, 1), y: 1.67, y1: 1.65, y2: 0.67, y3: 2.61 },
      ],

      border_010: { width: 1, color: "#ffffff" },

      // Per Chart 011
      seriesData_011_001: [
        { x: "USA", y: 46 },
        { x: "GBR", y: 27 },
        { x: "CHN", y: 26 },
      ],

      seriesData_011_002: [
        { x: "USA", y: 37 },
        { x: "GBR", y: 23 },
        { x: "CHN", y: 18 },
      ],

      seriesData_011_003: [
        { x: "USA", y: 38 },
        { x: "GBR", y: 17 },
        { x: "CHN", y: 26 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_011: {
        valueType: "Category",
        interval: 1,
        majorGridLines: { width: 0 },
        font: { fontWeight: "bold", color: "#ffffff" },
        labelStyle: {
          size: "14px",
          fontWeight: "bold",
        },
      },
      chartArea_011: { border: { width: 0 } },

      //Initializing Primary Y Axis
      primaryYAxis_011: {
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
        labelStyle: { color: "transparent" },
      },
      marker_011: {
        dataLabel: {
          visible: true,
          position: "Top",
          font: { fontWeight: "600", color: "#ffffff" },
        },
      },
      marker_011b: {
        dataLabel: {
          visible: true,
          position: "Auto", //"Outer",//"Top",
          font: { fontWeight: "600", color: "black" },
        },
      },

      // Per Chart 012
      seriesData_012_01: [
        { x: "2012", y: 104 },
        { x: "2016", y: 121 },
        { x: "2020", y: 113 },
      ],

      seriesData_012_02: [
        { x: "2012", y: 46 },
        { x: "2016", y: 46 },
        { x: "2020", y: 39 },
      ],

      seriesData_012_03: [
        { x: "2012", y: 65 },
        { x: "2016", y: 67 },
        { x: "2020", y: 65 },
      ],

      seriesData_012_04: [
        { x: "2012", y: 29 },
        { x: "2016", y: 27 },
        { x: "2020", y: 22 },
      ],

      seriesData_012_05: [
        { x: "2012", y: 91 },
        { x: "2016", y: 70 },
        { x: "2020", y: 88 },
      ],

      seriesData_012_06: [
        { x: "2012", y: 38 },
        { x: "2016", y: 26 },
        { x: "2020", y: 38 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_012: {
        valueType: "Category",
        interval: 1,
        majorGridLines: { width: 0 },
      },
      chartArea_012: { border: { width: 0 } },

      //Initializing Primary Y Axis
      primaryYAxis_012: {
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
        labelStyle: { color: "transparent" },
      },
      marker_012: {
        dataLabel: {
          visible: true,
          position: "Top",
          font: { fontWeight: "600", color: "#ffffff" },
        },
      },

      // Per Chart 013
      cornerRadius_013: {
        bottomLeft: 10,
        bottomRight: 10,
        topLeft: 10,
        topRight: 10,
      },

      // Per Chart 014

      seriesData_014_01: [
        { x: "Sun", low: 3.1, high: 10.8 },
        { x: "Mon", low: 5.7, high: 14.4 },
        { x: "Tue", low: 8.4, high: 16.9 },
        { x: "Wed", low: 10.6, high: 19.2 },
        { x: "Thu", low: 8.5, high: 16.1 },
        { x: "Fri", low: 6.0, high: 12.5 },
        { x: "Sat", low: 1.5, high: 6.9 },
      ],

      seriesData_014_02: [
        { x: "Sun", low: 2.5, high: 9.8 },
        { x: "Mon", low: 4.7, high: 11.4 },
        { x: "Tue", low: 6.4, high: 14.4 },
        { x: "Wed", low: 9.6, high: 17.2 },
        { x: "Thu", low: 7.5, high: 15.1 },
        { x: "Fri", low: 3.0, high: 10.5 },
        { x: "Sat", low: 1.2, high: 7.9 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_014: {
        valueType: "Category",
        majorGridLines: { width: 0 },
      },

      //Initializing Primary Y Axis
      primaryYAxis_014: {
        labelFormat: "{value}˚C",
        maximum: 20,
        edgeLabelPlacement: "Shift",
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
      },
      chartArea_014: {
        border: {
          width: 0,
        },
      },

      // Per Chart 017

      seriesData_017_01: [
        { x: "2014", y: 111.1 },
        { x: "2015", y: 127.3 },
        { x: "2016", y: 143.4 },
        { x: "2017", y: 159.9 },
      ],

      seriesData_017_02: [
        { x: "2014", y: 76.9 },
        { x: "2015", y: 99.5 },
        { x: "2016", y: 121.7 },
        { x: "2017", y: 142.5 },
      ],

      seriesData_017_03: [
        { x: "2014", y: 66.1 },
        { x: "2015", y: 79.3 },
        { x: "2016", y: 91.3 },
        { x: "2017", y: 102.4 },
      ],

      seriesData_017_04: [
        { x: "2014", y: 34.1 },
        { x: "2015", y: 38.2 },
        { x: "2016", y: 44.0 },
        { x: "2017", y: 51.6 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_017: {
        majorGridLines: { width: 0 },
        minorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
        interval: 1,
        lineStyle: { width: 0 },
        labelIntersectAction: "Rotate45",
        valueType: "Category",
      },

      //Initializing Primary Y Axis
      primaryYAxis_017: {
        title: "Sales",
        lineStyle: { width: 0 },
        minimum: 0,
        maximum: 500,
        interval: 100,
        majorTickLines: { width: 0 },
        majorGridLines: { width: 1 },
        minorGridLines: { width: 1 },
        minorTickLines: { width: 0 },
        labelFormat: "{value}B",
      },
      chartArea_017: {
        border: {
          width: 0,
        },
      },

      // Per Chart 018

      //Initializing Primary X Axis
      primaryXAxis_018: {
        valueType: "Category",
        labelIntersectAction: "Rotate45",
        majorGridLines: { width: 0 },
        minorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },

      //Initializing Primary Y Axis
      primaryYAxis_018: {
        title: "GDP (%) per Annum",
        rangePadding: "None",
        interval: 20,
        majorTickLines: { width: 0 },
        majorGridLines: { width: 1 },
        minorGridLines: { width: 1 },
        minorTickLines: { width: 0 },
        lineStyle: {
          width: 0,
        },
      },
      chartArea_018: {
        border: {
          width: 0,
        },
      },

      tooltip_018: {
        enable: true,
        format: "${point.x} : <b>${point.y} (${point.percentage}%)</b>",
      },

      // Per Chart 019

      seriesData_019_01: [
        { x: "Jan", y: 6 },
        { x: "Feb", y: 8 },
        { x: "Mar", y: 12 },
        { x: "Apr", y: 15.5 },
        { x: "May", y: 20 },
        { x: "Jun", y: 24 },
      ],

      seriesData_019_02: [
        { x: "Jan", y: 6 },
        { x: "Feb", y: 8 },
        { x: "Mar", y: 11 },
        { x: "Apr", y: 16 },
        { x: "May", y: 21 },
        { x: "Jun", y: 25 },
      ],

      seriesData_019_03: [
        { x: "Jan", y: -1 },
        { x: "Feb", y: -1.5 },
        { x: "Mar", y: -2 },
        { x: "Apr", y: -2.5 },
        { x: "May", y: -3 },
        { x: "Jun", y: -3.5 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_019: {
        valueType: "Category",
        majorGridLines: { width: 0 },
      },
      chartArea_019: {
        border: {
          width: 0,
        },
      },

      //Initializing Primary Y Axis
      primaryYAxis_019: {
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        labelFormat: "{value}%",
        edgeLabelPlacement: "Shift",
      },

      // Per Chart 020

      seriesData_020_01: [
        { x: "Jan", y: 6, y1: 6, y2: 1 },
        { x: "Feb", y: 8, y1: 8, y2: 1.5 },
        { x: "Mar", y: 12, y1: 11, y2: 2 },
        { x: "Apr", y: 15, y1: 16, y2: 2.5 },
        { x: "May", y: 20, y1: 21, y2: 3 },
        { x: "Jun", y: 24, y1: 25, y2: 3.5 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_020: {
        valueType: "Category",
        majorGridLines: { width: 0 },
      },

      //Initializing Primary Y Axis
      primaryYAxis_020: {
        edgeLabelPlacement: "Shift",
      },
      chartArea_020: {
        border: {
          width: 0,
        },
      },

      // per chart 021

      seriesData_021_01: [
        { x: "4.5", y: 31 },
        { x: "4.8", y: 37 },
        { x: "5.1", y: 49 },
        { x: "5.4", y: 57 },
        { x: "5.7", y: 63 },
        { x: "6", y: 69 },
      ],
      seriesData_021_02: [
        { x: "4.5", y: -31, text: "31 KG" },
        { x: "4.8", y: -39, text: "39 KG" },
        { x: "5.1", y: -52, text: "52 KG" },
        { x: "5.4", y: -64, text: "64 KG" },
        { x: "5.7", y: -70, text: "70 KG" },
        { x: "6", y: -74, text: "74 KG" },
      ],
      //Initializing Primary X Axis
      primaryXAxis_021: {
        valueType: "Category",
        title: "Height in Inches",
        minorGridLines: { width: 0 },
        minorTickLines: { width: 0 },
        interval: 1,
        majorGridLines: { width: 0 },
      },
      //Initializing Primary Y Axis
      primaryYAxis_021: {
        labelFormat: "{value} KG",
        edgeLabelPlacement: "Shift",
        majorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
        labelStyle: {
          color: "transparent",
        },
      },
      chartArea_021: {
        border: {
          width: 0,
        },
      },
      marker_021_01: {
        dataLabel: {
          visible: true,
          position: "Top",
          font: {
            fontWeight: "600",
          },
        },
      },
      marker_021_02: {
        dataLabel: {
          name: "text",
          visible: true,
          position: "Top",
          font: {
            fontWeight: "600",
          },
        },
      },

      // per chart 022
      seriesData_022_01: [
        { x: 131, y: 62 },
        { x: 140, y: 62 },
        { x: 149, y: 62 },
        { x: 115, y: 62 },
        { x: 134, y: 62 },
        { x: 183, y: 62 },
        { x: 155, y: 62 },
        { x: 164, y: 62 },
        { x: 169, y: 62 },
        { x: 122, y: 62 },
        { x: 161, y: 62 },
        { x: 166, y: 62 },
        { x: 137, y: 63 },
        { x: 140, y: 63 },
        { x: 140, y: 63 },
        { x: 126, y: 63 },
        { x: 150, y: 63 },
        { x: 153, y: 63 },
        { x: 154, y: 63 },
        { x: 139, y: 63 },
        { x: 164, y: 63 },
        { x: 162, y: 63 },
        { x: 167, y: 63 },
        { x: 146, y: 63 },
        { x: 150, y: 64 },
        { x: 141, y: 64 },
        { x: 142, y: 64 },
        { x: 129, y: 64 },
        { x: 159, y: 64 },
        { x: 158, y: 64 },
        { x: 162, y: 64 },
        { x: 136, y: 64 },
        { x: 176, y: 64 },
        { x: 170, y: 64 },
        { x: 167, y: 64 },
        { x: 144, y: 64 },
        { x: 143, y: 65 },
        { x: 137, y: 65 },
        { x: 137, y: 65 },
        { x: 140, y: 65 },
        { x: 161, y: 65 },
        { x: 150, y: 65 },
        { x: 155, y: 65 },
        { x: 160, y: 65 },
        { x: 182, y: 65 },
        { x: 168, y: 65 },
        { x: 181, y: 65 },
        { x: 165, y: 65 },
        { x: 148, y: 66 },
        { x: 145, y: 66 },
        { x: 137, y: 66 },
        { x: 138, y: 66 },
        { x: 162, y: 66 },
        { x: 166, y: 66 },
        { x: 159, y: 66 },
        { x: 151, y: 66 },
        { x: 180, y: 66 },
        { x: 181, y: 66 },
        { x: 174, y: 66 },
        { x: 159, y: 66 },
        { x: 151, y: 67 },
        { x: 148, y: 67 },
        { x: 141, y: 67 },
        { x: 145, y: 67 },
        { x: 165, y: 67 },
        { x: 168, y: 67 },
        { x: 159, y: 67 },
        { x: 183, y: 67 },
        { x: 188, y: 67 },
        { x: 187, y: 67 },
        { x: 172, y: 67 },
        { x: 193, y: 67 },
        { x: 153, y: 68 },
        { x: 153, y: 68 },
        { x: 147, y: 68 },
        { x: 163, y: 68 },
        { x: 174, y: 68 },
        { x: 173, y: 68 },
        { x: 160, y: 68 },
        { x: 191, y: 68 },
        { x: 189, y: 68 },
        { x: 182, y: 68 },
        { x: 181, y: 68 },
        { x: 196, y: 68 },
        { x: 152, y: 69 },
        { x: 173, y: 69 },
        { x: 190, y: 69 },
        { x: 161, y: 69 },
        { x: 173, y: 69 },
        { x: 185, y: 69 },
        { x: 141, y: 69 },
        { x: 149, y: 69 },
        { x: 186, y: 69 },
        { x: 188, y: 69 },
        { x: 148, y: 69 },
        { x: 174, y: 69 },
        { x: 164, y: 70 },
        { x: 182, y: 70 },
        { x: 200, y: 70 },
        { x: 151, y: 70 },
        { x: 162, y: 70 },
        { x: 200, y: 70 },
        { x: 166, y: 70 },
        { x: 177, y: 70 },
        { x: 188, y: 70 },
        { x: 156, y: 70 },
        { x: 175, y: 70 },
        { x: 191, y: 70 },
        { x: 174, y: 71 },
        { x: 187, y: 71 },
        { x: 208, y: 71 },
        { x: 166, y: 71 },
        { x: 150, y: 71 },
        { x: 194, y: 71 },
        { x: 157, y: 71 },
        { x: 183, y: 71 },
        { x: 204, y: 71 },
        { x: 162, y: 71 },
        { x: 179, y: 71 },
        { x: 196, y: 71 },
        { x: 170, y: 72 },
        { x: 184, y: 72 },
        { x: 197, y: 72 },
        { x: 162, y: 72 },
        { x: 177, y: 72 },
        { x: 203, y: 72 },
        { x: 159, y: 72 },
        { x: 178, y: 72 },
        { x: 198, y: 72 },
        { x: 167, y: 72 },
        { x: 184, y: 72 },
        { x: 201, y: 72 },
        { x: 167, y: 73 },
        { x: 178, y: 73 },
        { x: 215, y: 73 },
        { x: 207, y: 73 },
        { x: 172, y: 73 },
        { x: 204, y: 73 },
        { x: 162, y: 73 },
        { x: 182, y: 73 },
        { x: 201, y: 73 },
        { x: 172, y: 73 },
        { x: 189, y: 73 },
        { x: 206, y: 73 },
        { x: 150, y: 74 },
        { x: 187, y: 74 },
        { x: 153, y: 74 },
        { x: 171, y: 74 },
        { x: 214, y: 74 },
        { x: 211, y: 74 },
        { x: 166, y: 74 },
        { x: 185, y: 74 },
        { x: 204, y: 74 },
        { x: 177, y: 74 },
        { x: 194, y: 74 },
        { x: 212, y: 74 },
      ],
      seriesData_022_02: [
        { x: 115, y: 57 },
        { x: 138, y: 57 },
        { x: 166, y: 57 },
        { x: 122, y: 57 },
        { x: 126, y: 57 },
        { x: 130, y: 57 },
        { x: 125, y: 57 },
        { x: 144, y: 57 },
        { x: 150, y: 57 },
        { x: 120, y: 57 },
        { x: 125, y: 57 },
        { x: 130, y: 57 },
        { x: 103, y: 58 },
        { x: 116, y: 58 },
        { x: 130, y: 58 },
        { x: 126, y: 58 },
        { x: 136, y: 58 },
        { x: 148, y: 58 },
        { x: 119, y: 58 },
        { x: 141, y: 58 },
        { x: 159, y: 58 },
        { x: 120, y: 58 },
        { x: 135, y: 58 },
        { x: 163, y: 58 },
        { x: 119, y: 59 },
        { x: 131, y: 59 },
        { x: 148, y: 59 },
        { x: 123, y: 59 },
        { x: 137, y: 59 },
        { x: 149, y: 59 },
        { x: 121, y: 59 },
        { x: 142, y: 59 },
        { x: 160, y: 59 },
        { x: 118, y: 59 },
        { x: 130, y: 59 },
        { x: 146, y: 59 },
        { x: 119, y: 60 },
        { x: 133, y: 60 },
        { x: 150, y: 60 },
        { x: 133, y: 60 },
        { x: 149, y: 60 },
        { x: 165, y: 60 },
        { x: 130, y: 60 },
        { x: 139, y: 60 },
        { x: 154, y: 60 },
        { x: 118, y: 60 },
        { x: 152, y: 60 },
        { x: 154, y: 60 },
        { x: 130, y: 61 },
        { x: 145, y: 61 },
        { x: 166, y: 61 },
        { x: 131, y: 61 },
        { x: 143, y: 61 },
        { x: 162, y: 61 },
        { x: 131, y: 61 },
        { x: 145, y: 61 },
        { x: 162, y: 61 },
        { x: 115, y: 61 },
        { x: 149, y: 61 },
        { x: 183, y: 61 },
        { x: 121, y: 62 },
        { x: 139, y: 62 },
        { x: 159, y: 62 },
        { x: 135, y: 62 },
        { x: 152, y: 62 },
        { x: 178, y: 62 },
        { x: 130, y: 62 },
        { x: 153, y: 62 },
        { x: 172, y: 62 },
        { x: 114, y: 62 },
        { x: 135, y: 62 },
        { x: 154, y: 62 },
        { x: 126, y: 63 },
        { x: 141, y: 63 },
        { x: 160, y: 63 },
        { x: 135, y: 63 },
        { x: 149, y: 63 },
        { x: 180, y: 63 },
        { x: 132, y: 63 },
        { x: 144, y: 63 },
        { x: 163, y: 63 },
        { x: 122, y: 63 },
        { x: 146, y: 63 },
        { x: 156, y: 63 },
        { x: 133, y: 64 },
        { x: 150, y: 64 },
        { x: 176, y: 64 },
        { x: 133, y: 64 },
        { x: 149, y: 64 },
        { x: 176, y: 64 },
        { x: 136, y: 64 },
        { x: 157, y: 64 },
        { x: 174, y: 64 },
        { x: 131, y: 64 },
        { x: 155, y: 64 },
        { x: 191, y: 64 },
        { x: 136, y: 65 },
        { x: 149, y: 65 },
        { x: 177, y: 65 },
        { x: 143, y: 65 },
        { x: 149, y: 65 },
        { x: 184, y: 65 },
        { x: 128, y: 65 },
        { x: 146, y: 65 },
        { x: 157, y: 65 },
        { x: 133, y: 65 },
        { x: 153, y: 65 },
        { x: 173, y: 65 },
        { x: 141, y: 66 },
        { x: 156, y: 66 },
        { x: 175, y: 66 },
        { x: 125, y: 66 },
        { x: 138, y: 66 },
        { x: 165, y: 66 },
        { x: 122, y: 66 },
        { x: 164, y: 66 },
        { x: 182, y: 66 },
        { x: 137, y: 66 },
        { x: 157, y: 66 },
        { x: 176, y: 66 },
        { x: 149, y: 67 },
        { x: 159, y: 67 },
        { x: 179, y: 67 },
        { x: 156, y: 67 },
        { x: 179, y: 67 },
        { x: 186, y: 67 },
        { x: 147, y: 67 },
        { x: 166, y: 67 },
        { x: 185, y: 67 },
        { x: 140, y: 67 },
        { x: 160, y: 67 },
        { x: 180, y: 67 },
        { x: 145, y: 68 },
        { x: 155, y: 68 },
        { x: 170, y: 68 },
        { x: 129, y: 68 },
        { x: 164, y: 68 },
        { x: 189, y: 68 },
        { x: 150, y: 68 },
        { x: 157, y: 68 },
        { x: 183, y: 68 },
        { x: 144, y: 68 },
        { x: 170, y: 68 },
        { x: 180, y: 68 },
      ],
      //Initializing Primary X Axis
      primaryXAxis_022: {
        majorGridLines: { width: 0 },
        minimum: 100,
        maximum: 220,
        edgeLabelPlacement: "Shift",
        title: "Height (cm)",
      },
      chartArea_022: {
        border: {
          width: 0,
        },
      },

      //Initializing Primary Y Axis
      primaryYAxis_022: {
        majorTickLines: {
          width: 0,
        },
        minimum: 50,
        maximum: 80,
        lineStyle: {
          width: 0,
        },
        title: "Weight (kg)",
        rangePadding: "None",
      },

      marker_022_01: {
        visible: false,
        width: 12,
        height: 12,
        shape: "Circle",
      },

      marker_022_02: {
        visible: false,
        width: 12,
        height: 12,
        shape: "Diamond",
      },

      tooltip_022: {
        enable: true,
        format:
          "Weight: <b>${point.y} kg</b> <br/> Height: <b>${point.x}cm</b>",
      },

      // per chart 023
      seriesData_023_01: [
        { x: 92.2, y: 7.8, size: 1.347, text: "China" },
        { x: 74, y: 6.5, size: 1.241, text: "India" },
        { x: 90.4, y: 6.0, size: 0.238, text: "Indonesia" },
        { x: 99.4, y: 2.2, size: 0.312, text: "US" },
        { x: 88.6, y: 1.3, size: 0.197, text: "Brazil" },
        { x: 99, y: 0.7, size: 0.0818, text: "Germany" },
        { x: 72, y: 2.0, size: 0.0826, text: "Egypt" },
        { x: 99.6, y: 3.4, size: 0.143, text: "Russia" },
        { x: 99, y: 0.2, size: 0.128, text: "Japan" },
        { x: 86.1, y: 4.0, size: 0.115, text: "Mexico" },
        { x: 92.6, y: 6.6, size: 0.096, text: "Philippines" },
        { x: 61.3, y: 1.45, size: 0.162, text: "Nigeria" },
        { x: 82.2, y: 3.97, size: 0.7, text: "Hong Kong" },
        { x: 79.2, y: 3.9, size: 0.162, text: "Netherland" },
        { x: 72.5, y: 4.5, size: 0.7, text: "Jordan" },
        { x: 81, y: 3.5, size: 0.21, text: "Australia" },
        { x: 66.8, y: 3.9, size: 0.028, text: "Mongolia" },
        { x: 78.4, y: 2.9, size: 0.231, text: "Taiwan" },
      ],

      //Initializing Primary X Axis
      primaryXAxis_023: {
        title: "Literacy Rate",
        minimum: 60,
        maximum: 100,
        interval: 5,
      },

      //Initializing Primary Y Axis
      primaryYAxis_023: {
        title: "GDP Growth Rate",
        minimum: 0,
        maximum: 10,
        interval: 2.5,
      },

      marker_023: { dataLabel: { name: "text" } },

      pointRender_023: function (args) {
        let selectedTheme = location.hash.split("/")[1];
        selectedTheme = selectedTheme ? selectedTheme : "Material";
        if (selectedTheme && selectedTheme.indexOf("fabric") > -1) {
          args.fill = fabricColors[args.point.index % 10];
        } else if (selectedTheme === "material") {
          args.fill = materialColors[args.point.index % 10];
        } else if (selectedTheme === "highcontrast") {
          args.fill = highContrastColors[args.point.index % 10];
        } else if (selectedTheme === "fluent") {
          args.fill = fluentColors[args.point.index % 10];
        } else if (selectedTheme === "fluent-dark") {
          args.fill = fluentDarkColors[args.point.index % 10];
        } else {
          args.fill = bootstrapColors[args.point.index % 10];
        }
      },

      tooltip_023: {
        enable: true,
        format:
          "${point.text}<br/>Literacy Rate : <b>${point.x}%</b>" +
          "<br/>GDP Annual Growth Rate : <b>${point.y}</b><br/>Population : <b>${point.size} Billion</b>",
      },

      // per chart 024

      primaryXAxis_024: {
        majorGridLines: { width: 0 },
        title: "Score of Final Examination",
        minimum: 0,
        maximum: 100,
      },
      chartArea_024: { border: { width: 0 } },
      legendSettings: { visible: false },
      primaryYAxis_024: {
        title: "Number of Students",
        minimum: 0,
        maximum: 50,
        interval: 10,
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
      },
      marker_024: {
        dataLabel: {
          visible: true,
          position: "Top",
          font: { fontWeight: "600", color: "#ffffff" },
        },
      },
      dataSource_024_01: chartData_024,
      tooltip_024: { enable: true },
      binInterval_024: 20,
      columnWidth: 0.99,
      showNormalDistribution: true,

      // per chart 025

      seriesData_025_01: [
        { x: "Chrome", y: 37, text: "37%" },
        { x: "UC Browser", y: 17, text: "17%" },
        { x: "iPhone", y: 19, text: "19%" },
        { x: "Others", y: 4, text: "4%" },
        { x: "Opera", y: 11, text: "11%" },
        { x: "Android", y: 12, text: "12%" },
      ],

      dataLabel_025: {
        visible: true,
        position: "Inside",
        name: "text",
        font: {
          fontWeight: "600",
        },
      },
      enableSmartLabels: true,
      enableAnimation_025: false,
      legendSettings_025: {
        visible: false,
      },
      tooltip_025: { enable: true, format: "${point.x} : <b>${point.y}%</b>" },

      startAngle: "0",
      endAngle: "360",
      radius: "70%",
      explodeOffset: "10%",
      explodeIndex: 0,
      center_025: { x: "50%", y: "50%" },
      title_025: "Mobile Browser Statistics",

      // per chart 026

      seriesData_026_01: [
        { x: "Argentina", y: 505370, r: "50%" },
        { x: "Belgium", y: 551500, r: "70%" },
        { x: "Cuba", y: 312685, r: "84%" },
        { x: "Dominican Republic", y: 350000, r: "97%" },
        { x: "Egypt", y: 301000, r: "84%" },
        { x: "Kazakhstan", y: 300000, r: "70%" },
        { x: "Somalia", y: 357022, r: "90%" },
      ],
      radius_026: "r",
      dataLabel_026: { visible: true, position: "Outside", name: "x" },
      legendSettings_026: { visible: true, reverse: true },

      // per chart 027

      seriesData_027_01: [
        { x: "Labour", y: 18, text: "18%" },
        { x: "Legal", y: 8, text: "8%" },
        { x: "Production", y: 15, text: "15%" },
        { x: "License", y: 11, text: "11%" },
        { x: "Facilities", y: 18, text: "18%" },
        { x: "Taxes", y: 14, text: "14%" },
        { x: "Insurance", y: 16, text: "16%" },
      ],

      //Initializing Primary X Axis
      primaryXAxis_027: {
        title: "Years",
        labelIntersectAction: "Rotate45",
        valueType: "Category",
        majorGridLines: { width: 0 },
        minorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
        lineStyle: { width: 0 },
      },

      //Initializing Primary Y Axis
      primaryYAxis_027: {
        title: "Growth",
        minimum: -3,
        maximum: 3,
        interval: 1,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        majorGridLines: { width: 1 },
        minorGridLines: { width: 1 },
        minorTickLines: { width: 0 },
        labelFormat: "{value}B",
      },
      chartArea_027: {
        border: {
          width: 0,
        },
      },
      dataLabel_027: {
        visible: true,
        name: "text",
        position: "Inside",
        font: {
          fontWeight: "600",
          color: "#ffffff",
        },
      },
      legendSettings_027: {
        visible: true,
        position: "Top",
      },
      tooltip_027: { enable: true },

      explodeIndex_027: 3,
      title_027: "Project Cost Breakdown",

      // per chart 028

      seriesData_028_01: [
        { x: "Sweet Treats", y: 120, text: "120 cal" },
        { x: "Milk, Youghnut, Cheese", y: 435, text: "435 cal" },
        { x: "Vegetables", y: 470, text: "470 cal" },
        { x: "Meat, Poultry, Fish", y: 475, text: "475 cal" },
        { x: "Fruits", y: 520, text: "520 cal" },
        { x: "Bread, Rice, Pasta", y: 930, text: "930 cal" },
      ],

      //Initializing Primary X Axis
      primaryXAxis_028: {
        title: "Years",
        interval: Browser.isDevice ? 2 : 1,
        labelIntersectAction: "Rotate45",
        valueType: "Category",
        majorGridLines: { width: 0 },
        minorGridLines: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
        lineStyle: { width: 0 },
      },

      //Initializing Primary Y Axis
      primaryYAxis_028: {
        title: "Growth",
        minimum: -3,
        maximum: 3,
        interval: 1,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        majorGridLines: { width: 1 },
        minorGridLines: { width: 1 },
        minorTickLines: { width: 0 },
        labelFormat: "{value}B",
      },

      dataLabel_028: {
        name: "text",
        visible: true,
        position: "Inside",
        font: {
          fontWeight: "600",
        },
      },

      emptyPointSettings_028: { mode: "Drop", fill: "red" },

      legendSettings_028: {
        visible: false,
      },

      tooltip_028: {
        enable: true,
        format: "${point.x} : <b>${point.y} cal</b>",
      },

      title_028: "Food Comparison Chart",

      // per chart 029

      seriesData_029_01: [
        { x: "China", y: 1409517397, text: "China" },
        { x: "India", y: 1339180127, text: "India" },
        { x: "United States", y: 324459463, text: "United States" },
        { x: "Indonesia", y: 263991379, text: "Indonesia" },
        { x: "Brazil", y: 209288278, text: "Brazil" },
        { x: "Pakistan", y: 197015955, text: "Pakistan" },
        { x: "Nigeria", y: 190886311, text: "Nigeria" },
        { x: "Bangladesh", y: 164669751, text: "Bangladesh" },
        { x: "Russia", y: 143989754, text: "Russia" },
        { x: "Mexico", y: 129163276, text: "Mexico" },
        { x: "Japan", y: 127484450, text: " Japan" },
        { x: "Ethiopia", y: 104957438, text: "Ethiopia" },
        { x: "Philippines", y: 104918090, text: "Philippines" },
        { x: "Egypt", y: 97553151, text: "Egypt" },
        { x: "Vietnam", y: 95540800, text: "Vietnam" },
        { x: "Germany", y: 82114224, text: "Germany" },
      ],
      neckWidth_029: "15%",
      neckHeight_029: "18%",
      dataLabel_029: {
        visible: true,
        position: "Outside",
        connectorStyle: { length: "6%" },
        name: "text",
      },
      explode_029: false,
      legendSettings_029: {
        visible: false,
      },

      tooltip_029: { enable: true, format: "${point.x} : <b>${point.y}</b>" },

      title_029: "Top populated countries in 2017",

      // per chart 030

      seriesData_030_01: [
        { x: "Australia", y: 53, text: "AUS: 14%" },
        { x: "China", y: 56, text: "CHN: 15%" },
        { x: "India", y: 61, text: "IND: 16%" },
        { x: "Japan", y: 13, text: "JPN: 3%" },
        { x: "South Africa", y: 79, text: "ZAF: 21%" },
        { x: "United Kingdom", y: 71, text: "UK: 19%" },
        { x: "United States", y: 45, text: "USA: 12%" },
      ],

      dataLabel_030: {
        visible: true,
        position: "Outside",
        connectorStyle: { length: "10%" },
        name: "text",
        font: { size: "14px" },
      },

      legendSettings_030: {
        visible: false,
      },
      startAngle_030: 270,
      endAngle_030: 90,
      tooltip_030: { enable: true, format: "${point.x} : <b>${point.y}</b>" },

      innerRadius_030: "40%",

      isExplode_030: true,

      title_030: "Agricultural Land Percentage",

      // per Chart 031
      isClosed_031: true,
      seriesData_031_01: [
        { x: "Jan", y: -7.1 },
        { x: "Feb", y: -3.7 },
        { x: "Mar", y: 0.8 },
        { x: "Apr", y: 6.3 },
        { x: "May", y: 13.3 },
        { x: "Jun", y: 18.0 },
        { x: "Jul", y: 19.8 },
        { x: "Aug", y: 18.1 },
        { x: "Sep", y: 13.1 },
        { x: "Oct", y: 4.1 },
        { x: "Nov", y: -3.8 },
        { x: "Dec", y: -6.8 },
      ],
      seriesData_031_02: [
        { x: "Jan", y: -17.4 },
        { x: "Feb", y: -15.6 },
        { x: "Mar", y: -12.3 },
        { x: "Apr", y: -5.3 },
        { x: "May", y: 1.0 },
        { x: "Jun", y: 6.9 },
        { x: "Jul", y: 9.4 },
        { x: "Aug", y: 7.6 },
        { x: "Sep", y: 2.6 },
        { x: "Oct", y: -4.9 },
        { x: "Nov", y: -13.4 },
        { x: "Dec", y: -16.4 },
      ],
      //Initializing Primary X Axis
      primaryXAxis_031: {
        title: "Months",
        valueType: "Category",
        labelPlacement: "OnTicks",
        interval: 1,
        coefficient: Browser.isDevice ? 80 : 100,
      },
      //Initializing Primary Y Axis
      primaryYAxis_031: {
        title: "Temperature (Celsius)",
        minimum: -25,
        maximum: 25,
        interval: 10,
        edgeLabelPlacement: "Shift",
        labelFormat: "{value}°C",
      },
      marker_031_01: {
        visible: true,
        height: 10,
        width: 10,
        shape: "Pentagon",
      },
      marker_031_02: {
        visible: true,
        height: 10,
        width: 10,
        shape: "Diamond",
      },
      tooltip_031: {
        enable: true,
      },
      title_031: "Alaska Weather Statistics - 2016",
      seriesType_031: "Polar",

      // per chart 033
      seriesData_033_01: [
        { x: "2000", y: 4 },
        { x: "2001", y: 3.0 },
        { x: "2002", y: 3.8 },
        { x: "2003", y: 3.4 },
        { x: "2004", y: 3.2 },
        { x: "2005", y: 3.9 },
      ],

      seriesData_033_02: [
        { x: "2000", y: 2.6 },
        { x: "2001", y: 2.8 },
        { x: "2002", y: 2.6 },
        { x: "2003", y: 3 },
        { x: "2004", y: 3.6 },
        { x: "2005", y: 3 },
      ],

      seriesData_033_03: [
        { x: "2000", y: 2.8 },
        { x: "2001", y: 2.5 },
        { x: "2002", y: 2.8 },
        { x: "2003", y: 3.2 },
        { x: "2004", y: 2.9 },
        { x: "2005", y: 2 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_033: {
        valueType: "Category",
        labelPlacement: "OnTicks",
        interval: 1,
        coefficient: Browser.isDevice ? 80 : 100,
      },

      //Initializing Primary Y Axis
      primaryYAxis_033: {
        title: "Revenue in Millions",
        labelFormat: "{value}M",
      },

      border_033: { color: "transparent" },

      title_033: "Average Sales Comparison",
      seriesType_033: "Polar",

      // per chart 034
      seriesData_034_01: [
        { x: "JPN", text: "Japan", y: 5156, y1: 4849, y2: 4382, y3: 4939 },
        { x: "DEU", text: "Germany", y: 3754, y1: 3885, y2: 3365, y3: 3467 },
        { x: "FRA", text: "France", y: 2809, y1: 2844, y2: 2420, y3: 2463 },
        { x: "GBR", text: "UK", y: 2721, y1: 3002, y2: 2863, y3: 2629 },
        { x: "BRA", text: "Brazil", y: 2472, y1: 2456, y2: 1801, y3: 1799 },
        { x: "RUS", text: "Russia", y: 2231, y1: 2064, y2: 1366, y3: 1281 },
        { x: "ITA", text: "Italy", y: 2131, y1: 2155, y2: 1826, y3: 1851 },
        { x: "IND", text: "India", y: 1857, y1: 2034, y2: 2088, y3: 2256 },
        { x: "CAN", text: "Canada", y: 1843, y1: 1793, y2: 1553, y3: 1529 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_034: {
        valueType: "Category",
        labelPlacement: "OnTicks",
        interval: 1,
        coefficient: Browser.isDevice ? 80 : 100,
      },

      legendSettings_034: {
        visible: true,
      },
      tooltip_034: {
        enable: true,
      },
      animation_034: { enable: true },

      polarwidth: 120,
      seriesType_034: "Polar",

      title_034: "GDP, Current Prices (in Billions)",

      // per chart 035
      seriesData_035_01: [
        { text: "Myanmar", x: "MMR", y: 7.3, y1: 6.3, y2: 7.5 },
        { text: "India", x: "IND", y: 7.9, y1: 6.8, y2: 7.2 },
        { text: "Bangladesh", x: "BGD", y: 6.8, y1: 6.9, y2: 6.9 },
        { text: "Cambodia", x: "KHM", y: 7.0, y1: 7.0, y2: 6.9 },
        { text: "China", x: "CHN", y: 6.9, y1: 6.7, y2: 6.6 },
        { text: "Bhutan", x: "BTN", y: 6.1, y1: 6.2, y2: 5.9 },
        { text: "Iceland", x: "ISL", y: 4.1, y1: 7.2, y2: 5.7 },
        { text: "Nepal", x: "NPL", y: 2.7, y1: 0.6, y2: 5.5 },
        { text: "Pakistan", x: "PAK", y: 4.0, y1: 4.7, y2: 5.0 },
        { text: "Poland", x: "POL", y: 3.9, y1: 2.7, y2: 3.4 },
        { text: "Australia", x: "AUS", y: 2.4, y1: 2.5, y2: 3.1 },
        { text: "Korea", x: "KOR", y: 2.8, y1: 2.8, y2: 2.7 },
        { text: "Singapore", x: "SGP", y: 1.9, y1: 2.0, y2: 2 },
        { text: "Canada", x: "CAN", y: 0.9, y1: 1.4, y2: 1.9 },
        { text: "Germany", x: "DEU", y: 1.5, y1: 1.8, y2: 1.6 },
        { text: "Denmark", x: "DNK", y: 1.6, y1: 1.1, y2: 1.5 },
        { text: "France", x: "FRA", y: 1.3, y1: 1.3, y2: 1.4 },
        { text: "Austria", x: "AUT", y: 1.0, y1: 1.5, y2: 1.4 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_035: {
        valueType: "Category",
        labelPlacement: "OnTicks",
        interval: 1,
        coefficient: Browser.isDevice ? 80 : 100,
      },

      //Initializing Primary Y Axis
      primaryYAxis_035: {
        minimum: 0,
        maximum: 8,
        interval: 2,
      },

      marker_035_01: { height: 10, width: 10, dataLabel: { name: "text" } },
      marker_035_02: {
        height: 10,
        width: 10,
        shape: "Diamond",
        dataLabel: { name: "text" },
      },
      marker_035_03: {
        height: 10,
        width: 10,
        shape: "Triangle",
        dataLabel: { name: "text" },
      },
      tooltip_035: {
        enable: true,
        format: "${point.text} : <b>${point.y}%</b>",
      },

      seriesType_035: "Polar",

      title_035: "Real GDP Growth",

      // per chart 036
      seriesData_036_01: [
        { text: "Japan", x: "JPN", y: 137.9, y1: 127.6, y2: 108.8 },
        { text: "Indonesia", x: "IDN", y: 85.0, y1: 246.9, y2: 45.5 },
        { text: "Russia", x: "RUS", y: 237.1, y1: 143.5, y2: 41.2 },
        { text: "Vietnam", x: "VNM", y: 127.7, y1: 88.8, y2: 18.0 },
        { text: "Pakistan", x: "PAK", y: 126.1, y1: 179.2, y2: null },
        { text: "Nigeria", x: "NGA", y: 175.0, y1: 168.8, y2: 12.7 },
        { text: "Germany", x: "DEU", y: 113.6, y1: 81.9, y2: 46.0 },
        { text: "Bangladesh", x: "BGS", y: 116.0, y1: 154.7, y2: 34.6 },
        { text: "Philippines", x: "PHL", y: 109.5, y1: 96.7, y2: 16.6 },
        { text: "Mexico", x: "MEX", y: 102.7, y1: 120.8, y2: 19.8 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_036: {
        valueType: "Category",
        labelPlacement: "OnTicks",
        interval: 1,
        coefficient: Browser.isDevice ? 80 : 100,
      },

      //Initializing Primary Y Axis
      primaryYAxis_036: {
        labelFormat: "{value}M",
      },

      border_036: { width: 1, color: "white" },

      marker_036: { dataLabel: { name: "text" } },

      tooltip_036: {
        enable: true,
        format: "${point.text} : <b>${point.y}%</b>",
      },
      title_036: "Top 10 Mobile Markets by Number of Subscriptions",
      seriesType_036: "Polar",

      // per chart 038
      seriesData_038_01: [
        { x: "Jan", low: 2, high: 7 },
        { x: "Feb", low: 3, high: 7 },
        { x: "Mar", low: 3, high: 7 },
        { x: "Apr", low: 4, high: 9 },
        { x: "May", low: 6, high: 11 },
        { x: "June", low: 8, high: 14 },
      ],

      //Initializing Primary X Axis
      primaryXAxis_038: {
        valueType: "Category",
        title: "Months",
        interval: 1,
        labelPlacement: "OnTicks",
        startAngle: 90,
        coefficient: Browser.isDevice ? 80 : 100,
      },

      //Initializing Primary Y Axis
      primaryYAxis_038: {
        labelFormat: "{value}˚C",
        minimum: 0,
        maximum: 15,
        interval: 5,
      },

      border_038: { width: 3, color: "white" },
      legendSettings_038: { visible: false },
      seriesType_038: "Polar",
      title_038: "Maximum and Minimum Temperature",
      marker_038: {
        dataLabel: {
          visible: true,
          position: "Top",
          font: { color: "#ffffff", fontWeight: "600" },
          enableRotation: true,
        },
      },

      // per chart 039

      seriesData_039_01: [
        { x: 1, y: 20 },
        { x: 2, y: 22 },
        { x: 3, y: 0 },
        { x: 4, y: 12 },
        { x: 5, y: 5 },
        { x: 6, y: 15 },
        { x: 7, y: 6 },
        { x: 8, y: 12 },
        { x: 9, y: 20 },
        { x: 10, y: 7 },
      ],
      primaryYAxis_039: {
        title: "Runs",
        stripLines: [
          {
            start: 15,
            end: 22,
            text: "Good",
            color: "#ff512f",
            visible: true,
            zIndex: "Behind",
            opacity: 0.5,
          },
          {
            start: 8,
            end: 15,
            text: "Medium",
            color: "pink",
            opacity: 0.5,
            visible: true,
            zIndex: "Behind",
          },
          {
            start: 0,
            end: 8,
            text: "Not enough",
            color: "skyblue",
            opacity: 0.5,
            visible: true,
            zIndex: "Behind",
          },
        ],
      },
      primaryXAxis_039: {
        title: "Overs",
      },
      title_039: "India Vs Australia 1st match",

      // per chart 040

      primaryYAxis_040: {
        title: "Runs",
      },
      primaryXAxis_040: {
        title: "Overs",
        stripLines: [
          {
            start: 0,
            end: 5,
            text: "powerplay 1",
            color: "red",
            visible: true,
            opacity: 0.5,
            rotation: 45,
            testStyle: { size: 20, color: "black" },
          },
          {
            start: 5,
            end: 10,
            text: "powerplay 2",
            color: "blue",
            visible: true,
            opacity: 0.5,
            rotation: 45,
            testStyle: { size: 20, color: "black" },
          },
        ],
      },

      // per chart 041
      seriesData_041_01: [
        { x: "Jan", low: 0.7, high: 6.1 },
        { x: "Feb", low: 1.3, high: 6.3 },
        { x: "Mar", low: 1.9, high: 8.5 },
        { x: "Apr", low: 3.1, high: 10.8 },
        { x: "May", low: 5.7, high: 14.4 },
        { x: "June", low: 8.4, high: 16.9 },
        { x: "July", low: 10.6, high: 19.2 },
        { x: "Aug", low: 10.5, high: 18.9 },
        { x: "Sep", low: 8.5, high: 16.1 },
        { x: "Oct", low: 6.0, high: 12.5 },
        { x: "Nov", low: 1.5, high: 6.9 },
        { x: "Dec", low: 5.1, high: 12.1 },
      ],
      primaryXAxis_041: {
        title: "Month",
        valueType: "Category",
        edgeLabelPlacement: "Shift",
      },
      primaryYAxis_041: {
        title: "Temperature(Celsius)",
        minimum: 0,
        maximum: 20,
      },
      title_041: "Maximum and Minimum Temperature",

      // per chart 043
      seriesData_043_01: series_043,
      primaryXAxis_043: {
        valueType: "DateTime",
        crosshairTooltip: { enable: true },
        labelFormat: "yMMM",
      },
      primaryYAxis_043: {
        crosshairTooltip: { enable: true },
      },
      title_043: "Weather Condition",
      crosshair_043: { enable: true },

      // per chart 044
      seriesData_044_01: [
        { x: new Date(2000, 2, 11), y: 15, y1: 39, y2: 60, y3: 75, y4: 85 },
        { x: new Date(2000, 9, 14), y: 20, y1: 30, y2: 55, y3: 75, y4: 83 },
        { x: new Date(2001, 2, 11), y: 25, y1: 28, y2: 48, y3: 68, y4: 85 },
        { x: new Date(2001, 9, 16), y: 21, y1: 35, y2: 57, y3: 75, y4: 87 },
        { x: new Date(2002, 2, 7), y: 13, y1: 39, y2: 62, y3: 71, y4: 82 },
        { x: new Date(2002, 9, 7), y: 18, y1: 41, y2: 64, y3: 69, y4: 74 },
        { x: new Date(2003, 2, 11), y: 24, y1: 45, y2: 57, y3: 81, y4: 73 },
        { x: new Date(2003, 9, 14), y: 23, y1: 48, y2: 53, y3: 84, y4: 75 },
        { x: new Date(2004, 2, 6), y: 19, y1: 54, y2: 63, y3: 85, y4: 73 },
        { x: new Date(2004, 9, 6), y: 31, y1: 55, y2: 50, y3: 87, y4: 60 },
        { x: new Date(2005, 2, 11), y: 39, y1: 57, y2: 66, y3: 75, y4: 48 },
        { x: new Date(2005, 9, 11), y: 50, y1: 60, y2: 65, y3: 70, y4: 55 },
        { x: new Date(2006, 2, 11), y: 24, y1: 60, y2: 79, y3: 85, y4: 40 },
      ],
      primaryXAxis_044: {
        title: "Years",
        minimum: new Date(2000, 1, 1),
        maximum: new Date(2006, 2, 11),
        intervalType: "Years",
        valueType: "DateTime",
      },
      title_044: "Average Sales per Person",
      crosshair_044: { enable: true, lineType: "Vertical" },
      tooltip_044: {
        enable: true,
        shared: true,
        format: "${series.name} : ${point.x} : ${point.y}",
      },
      marker_044_01: { visible: true },

      // per scheduler
      selectedDate: new Date(2022, 7, 24),
      eventSettings: {
        dataSource: [
          {
            Id: 1,
            Subject: "Scrum Meeting",
            Location: "Office",
            StartTime: new Date(2022, 7, 24, 9, 30),
            EndTime: new Date(2022, 7, 24, 10, 30),
            RecurrenceRule: "FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR;INTERVAL=1",
            CategoryColor: "olive",
          },
          {
            Id: 2,
            Subject: "Scrum 2",
            Location: "Agora",
            StartTime: new Date(2022, 8, 1, 11, 30),
            EndTime: new Date(2022, 8, 1, 12, 30),
            RecurrenceRule: "FREQ=WEEKLY;INTERVAL=1",
            CategoryColor: "purple",
          },
        ],
      },

      // per Kanban
      // kanbanData: [
      //   {
      //     Id: "T001",
      //     Title: "Mail Mr. Smith",
      //     Status: "DaSvolgere",
      //     Summary: "Scrivere mail per Mr. Smith.",
      //     Priority: "High",
      //     Tags: "Email, Prevendita",
      //     RankId: 1,
      //     Assignee: "Giulia Annovati",
      //     Argomento: "Marketing",
      //   },
      //   {
      //     Id: "T002",
      //     Title: "Lunch Smith",
      //     Status: "DaSvolgere",
      //     Summary: "Pranzo ristorante Astoria.",
      //     Priority: "High",
      //     Tags: "Postvendita",
      //     RankId: 2,
      //     Assignee: "Giulia Annovati",
      //     Argomento: "Customer Care",
      //   },
      // ],
      allowToggle: true,
      enableTooltip: true,
      swimlaneSettings: {
        keyField: "Argomento",
      },
      cardSettings: {
        headerField: "Title",
        template: function () {
          return { template: cardTemplate };
        },
        selectionType: "Multiple",
      },
      columnsTemplate: function () {
        return { template: columnTemplate };
      },
      // dialogSettings: {
      //   fields: [
      //     { text: "ID", key: "Title", type: "TextBox" },
      //     { key: "Status", type: "DropDown" },
      //     { key: "Argomento", type: "DropDown" },
      //     { key: "Assignee", type: "TextBox" },
      //     { key: "RankId", type: "TextBox" },
      //     { key: "Priority", type: "TextBox" },
      //     { key: "Summary", type: "TextArea" },
      //   ],
      // },

      // 101 - per chart 025 - Cate 001
      title_025_cate_001: "Pubblico per genere",
      seriesData_025_cate_001: [],

      // 102 - per chart 025 - Cate 002
      title_025_cate_002: "Pubblico per età",
      seriesData_025_cate_002: [],

      // 103 - per chart 025 - Cate 003
      title_025_cate_003: "Pubblico per provenienza",
      seriesData_025_cate_003: [],

      // per Donat027 - Cate 004_02
      seriesData_027_cate_004_02: [],

      // per chart 025 - Cate 005
      title_025_cate_005: "Pubblico 2022 per età",
      seriesData_025_cate_02: [
        { x: "Non Spec", y: 2280, text: "50%" },
        { x: "<20", y: 140, text: "3%" },
        { x: "20-40", y: 711, text: "15%" },
        { x: "40-60", y: 1130, text: "25%" },
        { x: "60-80", y: 340, text: "7%" },
      ],

      // per chart 025 - Cate 006
      title_025_cate_006: "Pubblico 2022 per provenienza",
      seriesData_025_cate_01: [],

      dataLabel_025_cate: {
        visible: true,
        position: "Inside",
        name: "text",
        font: {
          fontWeight: "600",
        },
        color: "purple",
      },
      enableSmartLabels: true,
      enableAnimation_025_cate: false,
      legendSettings_025_cate: {
        visible: true,
      },
      legendSettings_border: {
        padding: 10,
        shapePadding: 10,
        visible: true,
        border: {
          width: 2,
          color: "grey",
        },
        width: "200",
      },
      tooltip_025_cate: {
        enable: true,
        format: "${point.x} : <b>${point.y}</b>",
      },

      startAngle: "0",
      endAngle: "360",
      radius: "70%",
      explodeOffset: "10%",
      explodeIndex: 0,
      center_025_cate: { x: "50%", y: "50%" },

      // 201 - Per Chart 020 - Cate 007
      title_020_cate_007: "Genere del pubblico per spettacolo",
      seriesData_020_cate_007: [],

      // 202 - Per Chart 019 - Cate 007_2
      title_019_cate_007_2: "Genere del pubblico per spettacolo",
      tooltip_cate_007: {
        enable: true,
        format: "${point.x} : <b>${point.y} (${point.percentage}%)</b>",
      },
      //Initializing Primary Y Axis
      primaryYAxis_019_cate_007_2: {
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        labelFormat: "{value}",
        edgeLabelPlacement: "Shift",
      },
      // Donne
      seriesData_019_cate_007_01: [],
      // Uomini
      seriesData_019_cate_007_02: [],
      // Altro
      seriesData_019_cate_007_03: [],

      // 203 - Per Chart 019 - Cate 008
      title_019_cate_008: "Età del pubblico per spettacolo",
      // fascia <20
      seriesData_019_cate_008_01: [],
      // Fascia 20-40
      seriesData_019_cate_008_02: [],
      // Fascia 40-60
      seriesData_019_cate_008_03: [],
      // Fascia 60-80
      seriesData_019_cate_008_04: [],
      // Fascia Non specificato
      seriesData_019_cate_008_05: [],

      // 204 - Per Chart 019 - Cate 009
      title_019_cate_009: "Provenienza del pubblico per spettacolo",
      seriesData_019_cate_009_01: [],
      // Piemonte
      seriesData_019_cate_009_02: [],
      // Lombardia
      seriesData_019_cate_009_03: [],
      // Altro
      seriesData_019_cate_009_04: [],

      // Per Chart 016 - CATE 010
      title_bestSeller: "INCASSI SPETTACOLI",
      titleStyleBold: {
        //fontFamily: "Arial",
        //fontStyle: 'italic',
        fontWeight: "bold", //'1000',//'regular',
        //size: '18px'
      },
      seriesData_cate_bestSeller: [],

      palettes_bestSeller: [generateRandomColor()], //["#E94649"]
      //colors: ["#7d292b"],
      colors4: ["#a83b3e"],
      colors3: ["#cc474b"],
      colors2: ["#f2555a"],
      colors1: ["#fa7377"],

      // Per Chart 011 - CATE 002
      title_tipologia: "INCASSI PER TIPOLOGIA",
      title_tipologia_perc: "INCASSI PERCENTUALI PER TIPOLOGIA",
      seriesData_cate_tipologia: [],

      palettes_opera: ["#84b04a"],
      palettes_prosa: ["#3b75b3"],
      palettes_musical: ["#8b5aa3"],
      palettes_balletto: ["#64b6d9"],
      palettes_concerto: ["#e09c58"],
      palettes_eventi_diversi: ["#cc3d49"],

      palettes_tipologia: ["#b55153"], //[generateRandomColor()],//["#E94649"],

      palettes_incassi: ["#7d292b"],

      //
      // Per Chart 016 - CATE 003
      title_opera: "INCASSI OPERA",
      //seriesData_tipologia_opera: [],
      title_prosa: "INCASSI PROSA",
      title_musical: "INCASSI MUSICAL",
      title_balletto: "INCASSI BALLETTO",
      title_concerto: "INCASSI CONCERTO",
      title_eventi_diversi: "INCASSI EVENTI DIVERSI",
      //seriesData_tipologia_prosa: [],
      //
      // per chart 024 - Cate 011: istogramma

      title_024_cate: "Euro spesi per cliente [dummy]",
      primaryXAxis_024_cate: {
        majorGridLines: { width: 0 },
        title: "Euro spesi",
        minimum: 0,
        maximum: 100,
      },
      chartArea_024_cate: { border: { width: 0 } },
      legendSettings: { visible: false },
      primaryYAxis_024_cate: {
        title: "Numero di clienti",
        minimum: 0,
        maximum: 50,
        interval: 10,
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
      },
      marker_024_cate: {
        dataLabel: {
          visible: true,
          position: "Top",
          font: { fontWeight: "600", color: "#ffffff" },
        },
      },
      dataSource_024_cate_011: chartData_024_cate,
      tooltip_024_cate: { enable: true },
      binInterval_024_cate: 20,
      columnWidth: 0.99,
      showNormalDistribution: false, //cate

      // per chart  001 - cate 012
      title_001_cate_012: "Incassi per tipologia di pagamento",
      primaryXAxis_001_cate_012: {
        valueType: "DateTime",
        labelFormat: "m",
        intervalType: "Months",
        edgeLabelPlacement: "Shift",
        majorGridLines: { width: 0 },
      },
      primaryYAxis_001_cate_012: {
        labelFormat: "{value}%",
        rangePadding: "None",
        minimum: 0,
        maximum: 25000,
        interval: 1000,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },

      // 002 - Vendite per mese

      title_cate_012_02: "INCASSI MENSILI BIGLIETTERIA",
      primaryXAxis_001_cate_012_02: {
        valueType: "DateTime",
        labelFormat: "MMM", //monthSwitch("MMM"),
        labelStyle: { fontWeight: "bold" },
        intervalType: "Months",
        //edgeLabelPlacement: "Shift",
        majorGridLines: { width: 0 },
        // valueType: "DateTime",
        // labelFormat: "y",
        // intervalType: "Years",
        // edgeLabelPlacement: "Shift",
        // majorGridLines: { width: 0 },
      },
      primaryYAxis_001_cate_012_02: {
        labelFormat: "{value}",
        rangePadding: "None",
        minimum: 0,
        //maximum: 250000,
        interval: 50000,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },
      seriesData_001_cate_012_02_1: [],
      seriesData_001_cate_012_02_2: [],

      // vendite cumulative
      title_cate_cumulativo: "INCASSI TOTALI",
      seriesData_vendite_cumulative_01: [],
      primaryYAxis_001_cate_cumulativo: {
        labelFormat: "{value}",
        rangePadding: "None",
        minimum: 0,
        //maximum: 850000,
        interval: 50000,
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        minorTickLines: { width: 0 },
      },

      // 107 - Per Chart 011
      title_013_cate: "Pubblico per genere e provenienza",
      // Novara
      seriesData_011_001_cate_013: [],
      // Piemonte
      seriesData_011_002_cate_013: [],
      // Lombardia
      seriesData_011_003_cate_013: [],
      // Altro
      seriesData_011_004_cate_013: [],

      // Cate 014
      // Per Chart 011
      title_014_cate: "Pubblico per età e provenienza",
      // Novara
      seriesData_011_001_cate_014: [],
      // Piemonte
      seriesData_011_002_cate_014: [],
      // Lombardia
      seriesData_011_003_cate_014: [],
      // Altro
      seriesData_011_004_cate_014: [],
    };
  },
  created: function () {},
  mounted() {
    this.$refs.dropStagioni.ej2Instances.focusIn();
  },

  provide: {
    // PdfViewer: [
    //   PDFToolbar,
    //   Magnification,
    //   Navigation,
    //   LinkAnnotation,
    //   BookmarkView,
    //   ThumbnailView,
    //   Print,
    //   TextSelection,
    //   TextSearch,
    //   Annotation,
    //   FormFields,
    //   FormDesigner,
    // ],
    chart: [
      Crosshair,
      SplineRangeAreaSeries,
      StripLine,
      AreaSeries,
      SplineSeries,
      BarSeries,
      HistogramSeries,
      BubbleSeries,
      ScatterSeries,
      StackingColumnSeries,
      RangeColumnSeries,
      ColumnSeries,
      StackingAreaSeries,
      RangeAreaSeries,
      StepLineSeries,
      SplineAreaSeries,
      Category,
      Legend,
      DateTime,
      Tooltip,
      ChartZoom,
    ],
    accumulationchart: [
      AccumulationLegend,
      PolarSeries,
      RadarSeries,
      FunnelSeries,
      PyramidSeries,
      PieSeries,
      AccumulationTooltip,
      AccumulationDataLabel,
    ],
    // per scheduler
    // schedule: [Day, Week, WorkWeek, Month, Agenda],
    // per Kanban
    // kanban: [],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  updated: function () {
    // per chart 025
    this.$nextTick(function () {
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    });
  },
  components: {},
  methods: {
    // per refresh charts
    refreshChart: function () {
      console.log("Refresh Chart");
      this.$refs.chartcontainer_016_cate_010.ej2Instances.refresh();
      this.$refs.chartcontainer_011.ej2Instances.refresh();
      this.$refs.chartcontainer_016_cate_010a.ej2Instances.refresh();
      this.$refs.chartcontainer_016_cate_010b.ej2Instances.refresh();
      this.$refs.chartcontainer_016_cate_010c.ej2Instances.refresh();
      this.$refs.chartcontainer_016_cate_010d.ej2Instances.refresh();
      this.$refs.chartcontainer_016_cate_010e.ej2Instances.refresh();
      this.$refs.chartcontainer_016_cate_010f.ej2Instances.refresh();
      this.$refs.chartcontainer_007_cate_012_02.ej2Instances.refresh();
      this.$refs.chartcontainer_007_cate_cumulativo.ej2Instances.refresh();

      this.$refs.chartcontainer_020_cate_007.ej2Instances.refresh();
      this.$refs.chartcontainer_019_cate_007_2.ej2Instances.refresh();
      this.$refs.chartcontainer_019_cate_008.ej2Instances.refresh();
      this.$refs.chartcontainer_019_cate_009.ej2Instances.refresh();
      this.$refs.chartcontainer_011_cate_013.ej2Instances.refresh();
      this.$refs.chartcontainer_011_cate_014.ej2Instances.refresh();
    },

    // per aggiornamento aamplificatore altezza bar dei barchart
    computeBarHeightAmplifier: function (nBar) {
      if (nBar <= 3) {
        return 1;
      } else if (nBar > 3) {
        return 0.5;
      }
      return 1;
    },

    // per dropdownlist combinate
    onStagioneChange: function (e) {
      this.dropSceltaChartsEnabled = true;
      this.sceltaCharts = null;
      //this.sceltaChartsIndex= -1;
    },
    onSceltaChartsChange: function (e) {
      // spinner loading
      if (this.sceltaCharts != null) {
        // predispongo la visualizzazione dei risultati
        this.loading = true;
        this.$refs.contenuto.classList.add("offuscaContenuto");
        this.mostraContenuto = true;
      } else {
        // nascondo i charts
        this.mostraContenuto = false;
      }

      // this.$refs.contenuto.$el.classList.remove("offuscaContenuto");
      // this.$refs.contenuto.$el.classList.add("offuscaContenuto");

      // Inserire la chiamata per popolare i charts
      if (this.sceltaCharts == "graficiCompleti") {
          // dati stagione corrente
          console.log("Completo Anno Corrente");
          console.log(this.stagione)

          // chiamata API chart
          const richiesta = { query: "preparazioneCharts", anno: this.stagione };
          useJwt.post(chartUrl, richiesta).then((d) => {
            console.log("risposta backend");
            console.log(d.data);

            this.myWidth = 0.2;
            // chart bestseller
            this.seriesData_bestSeller = JSON.parse(d.data["ChartBestSeller"]);
            this.seriesData_tipologia = JSON.parse(d.data["ChartTipologia"]);
            this.seriesData_tipologia_pie = JSON.parse(
              d.data["ChartTipologiaPie"]
            );
            this.seriesData_tipologia_opera = JSON.parse(
              d.data["ChartTipologiaOpera"]
            );
            this.seriesData_tipologia_prosa = JSON.parse(
              d.data["ChartTipologiaProsa"]
            );
            this.seriesData_tipologia_musical = JSON.parse(
              d.data["ChartTipologiaMusical"]
            );
            this.seriesData_tipologia_balletto = JSON.parse(
              d.data["ChartTipologiaBalletto"]
            );
            this.seriesData_tipologia_concerto = JSON.parse(
              d.data["ChartTipologiaConcerto"]
            );
            this.seriesData_tipologia_eventi_diversi = JSON.parse(
              d.data["ChartTipologiaEventiDiversi"]
            );
            
            this.seriesData_019_cate_007_01 = JSON.parse(
              d.data["ChartSessoStackedBar"]["Donne"]
            );
            this.seriesData_019_cate_007_02 = JSON.parse(
              d.data["ChartSessoStackedBar"]["Uomini"]
            );
            this.seriesData_019_cate_007_03 = JSON.parse(
              d.data["ChartSessoStackedBar"]["Non Specificato"]
            );
            // chart vendite mese
            this.seriesData_001_cate_012_02_1 = eval(
              d.data["ChartVendutoMese"].replaceAll('"', "")
            );
            console.log(this.seriesData_001_cate_012_02_1);

            this.seriesData_vendite_cumulative_01 = eval(
              d.data["ChartVendutoCumulativo"].replaceAll('"', "")
            );

            // chart pie genere spettacoli stagione
            this.seriesData_025_cate_001 = JSON.parse(
              d.data["ChartGenereSpettacoliStagionePie"]
            );
            // stackedbar100 sesso
            this.seriesData_020_cate_007 = JSON.parse(
              d.data["ChartSessoStackedBar100"]
            );
            console.log(this.seriesData_020_cate_007);
            
            this.seriesData_011_001_cate_014 = JSON.parse(
              d.data["ChartAggregatoSessoProvinciaBarChartMulti"]["NO"]
            );
            this.seriesData_011_002_cate_014 = JSON.parse(
              d.data["ChartAggregatoSessoProvinciaBarChartMulti"]["Piemonte"]
            );
            this.seriesData_011_003_cate_014 = JSON.parse(
              d.data["ChartAggregatoSessoProvinciaBarChartMulti"]["Lombardia"]
            );
            this.seriesData_011_004_cate_014 = JSON.parse(
              d.data["ChartAggregatoSessoProvinciaBarChartMulti"]["Altre"]
            );

            // refresh chart
            this.refreshChart();
            // nascondi spinner
            this.loading = false;
            // toglie opacità
            this.$refs.contenuto.classList.remove("offuscaContenuto");
          });

      }
      else {
        console.log("Scelta tipologia non completa")
      }
    },
    // per chart 025
    pieangle: function (e) {
      let angle = document.getElementById("pieangle").value;
      this.endAngle = +angle;
      this.startAngle = +angle;
      document.getElementById("anglevalue").innerHTML = angle;
    },
    pieradius: function (e) {
      let rad = document.getElementById("pieradius").value;
      this.radius = rad + "%";
      document.getElementById("radiusid").innerHTML = (rad / 100).toFixed(2);
    },
    pieexploderadius: function (e) {
      let rad = document.getElementById("pieexploderadius").value;
      this.explodeOffset = rad + "%";
      document.getElementById("exploderadius").innerHTML = (rad / 100).toFixed(
        2
      );
    },
    pieexplodeindex: function (e) {
      let index = document.getElementById("pieexplodeindex").value;
      this.explodeIndex = +index;
      document.getElementById("explodeindex").innerHTML = index;
    },
    piecenterx: function (e) {
      let x = document.getElementById("x").value;
      this.$refs.pie.ej2Instances.center.x = x + "%";
      document.getElementById("xvalue").innerHTML = x + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
    piecentery: function (e) {
      let y = document.getElementById("y").value;
      this.$refs.pie.ej2Instances.center.y = y + "%";
      document.getElementById("yvalue").innerHTML = y + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },

    // per inserire il simbolo di Euro
    onTextRenderEuro: function (args) {
      args.text = parseInt(args.point.y) + "€";
    },

    // per inserire la percentuale nel barchart
    onSeriesRender: function (args) {
      if (total != 0) total = 0;
      for (let i = 0; i < args.data.length; i++) {
        total += parseInt(args.data[i].y);
      }
    },
    onTextRender: function (args) {
      let percentage = (parseInt(args.point.y) / total) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },

    onSeriesRender_03a: function (args) {
      if (total03a != 0) total03a = 0;
      for (let i = 0; i < args.data.length; i++) {
        total03a += parseInt(args.data[i].y);
      }
    },
    onTextRender_03a: function (args) {
      let percentage = (parseInt(args.point.y) / total03a) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },

    onSeriesRender_03b: function (args) {
      if (total03b != 0) total03b = 0;
      for (let i = 0; i < args.data.length; i++) {
        total03b += parseInt(args.data[i].y);
      }
    },
    onTextRender_03b: function (args) {
      let percentage = (parseInt(args.point.y) / total03b) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },

    onSeriesRender_03c: function (args) {
      if (total03c != 0) total03c = 0;
      for (let i = 0; i < args.data.length; i++) {
        total03c += parseInt(args.data[i].y);
      }
    },
    onTextRender_03c: function (args) {
      let percentage = (parseInt(args.point.y) / total03c) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },

    onSeriesRender_03d: function (args) {
      if (total03d != 0) total03d = 0;
      for (let i = 0; i < args.data.length; i++) {
        total03d += parseInt(args.data[i].y);
      }
    },
    onTextRender_03d: function (args) {
      let percentage = (parseInt(args.point.y) / total03d) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },

    onSeriesRender_03e: function (args) {
      if (total03e != 0) total03e = 0;
      for (let i = 0; i < args.data.length; i++) {
        total03e += parseInt(args.data[i].y);
      }
    },
    onTextRender_03e: function (args) {
      let percentage = (parseInt(args.point.y) / total03e) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },

    onSeriesRender_03f: function (args) {
      if (total03f != 0) total03f = 0;
      for (let i = 0; i < args.data.length; i++) {
        total03f += parseInt(args.data[i].y);
      }
      console.log("total: ");
      console.log(total03f);
    },
    onTextRender_03f: function (args) {
      let percentage = (parseInt(args.point.y) / total03f) * 100;
      percentage = percentage % 1 === 0 ? percentage : percentage.toFixed(1);
      args.text = parseInt(args.point.y) + "€ (" + percentage + "%)";
    },
    onTextRender_integer: function (args) {
      args.text = parseInt(args.point.y);
    },

    // colori distinti per barchart 5 categorie
    pointRender_002: function (args) {
      //var seriesColor = ['#00bdae', '#b077bf', '#357cd2', '#e56590', '#f8b883'];
      var seriesColor = [
        "#64b6d9",
        "#e09c58",
        "#cc3d49",
        "#8b5aa3",
        "#84b04a",
        "#3b75b3",
      ];
      args.fill = seriesColor[args.point.index];
    },

    myColumnWidthFunc: function (args) {
      var myColumnWidth = 1;
      if (args.length <= 3) {
        myColumnWidth = 0.2;
      }
      return myColumnWidth;
    },

    monthSwitch: function (args) {
      if (args == "Jan") {
        return "Gen";
      }
      if (args == "May") {
        return "Mag";
      }
      if (args == "Jun") {
        return "Giu";
      }
      if (args == "Jul") {
        return "Lug";
      }
      if (args == "Aug") {
        return "Ago";
      }
      if (args == "Sep") {
        return "Set";
      }
      if (args == "Oct") {
        return "Ott";
      }
      if (args == "Dec") {
        return "Dic";
      }
    },

    axisLabelRender1(args) {
      console.log(args.axis.name);
      if (args.axis.name === "primaryXAxis_001_cate_012_02") {
        console.log(args.axis.name);
        if (i === itaMonths.length) {
          i = 0;
        }
        args.text = itaMonths[i];
        i++;
      }
    },
  },
});

// functions CATE
function generateRandomColor() {
  var randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
  return randomColor;
}
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";

@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";

@import "~@syncfusion/ej2-navigations/styles/material.css";
@import "~@syncfusion/ej2-popups/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.offuscaContenuto {
  pointer-events: none; // disabilito gli effetti del mouse sopra il div
  opacity: 0.1; // rendo il div trasparente
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}
</style>
